import React from "react";
import {
    RenderNumber,
    RenderKilogramo,
} from "../../../../../../Utils/renderField/renderReadField";
import { getEtiquetasTraslado } from "../helpers/etiquetasTraslado";

export const ResumenTraslado = ({ trasladoForm }) => {
    const { destinoTraslado, totalPacasATrasladar, sobranteTraslado } =
        trasladoForm;

    const destinoEsConforme = destinoTraslado ? destinoTraslado.value : false;

    const { labelOrigen, labelDestino } =
        getEtiquetasTraslado(destinoEsConforme);

    return (
        <div className="traslado-control-calidad__footer gap-2rem flex-wrap py-3 px-4 my-4">
            <div className="d-flex align-items-center gap-1rem">
                <span className="text-nowrap">Pacas a trasladar</span>
                <h4 className="mb-0">
                    <RenderNumber value={totalPacasATrasladar} />
                </h4>
            </div>

            <div className="d-flex align-items-center gap-1rem">
                <span className="text-nowrap">Kg secos sobrantes a trasladar</span>
                <h4 className="mb-0">
                    <RenderKilogramo
                        value={sobranteTraslado.totalKgATrasladar}
                        decimalScale={2}
                    />
                </h4>
            </div>

            {destinoTraslado && (
                <div className="d-flex align-items-center gap-1rem">
                    <span
                        className={
                            destinoEsConforme
                                ? "traslado-control-calidad__legend-no-conforme"
                                : "traslado-control-calidad__legend-conforme"
                        }
                    >
                        {labelOrigen}
                    </span>
                    <span>&#8594;</span>
                    <span
                        className={
                            destinoEsConforme
                                ? "traslado-control-calidad__legend-conforme"
                                : "traslado-control-calidad__legend-no-conforme"
                        }
                    >
                        {labelDestino}
                    </span>
                </div>
            )}
        </div>
    );
};
